export default "__VITE_ASSET__11c5ef4e__"